<template>
  <div class="p-d-flex p-justify-center p-align-center" style="height: 100%">
    <div>
      <ul class="mt-5">
        <li class="mt-1">{{ $t("registration") }}</li>
        <li class="mt-1">{{ $t("invoicing") }}</li>
        <li class="mt-1">{{ $t("team-communications") }}</li>
        <li class="mt-1">{{ $t("player-communications") }}</li>
        <li class="mt-1">{{ $t("parent-communications") }}</li>
        <li class="mt-1">{{ $t("ticketing") }}</li>
        <li class="mt-1">{{ $t("and-more") }}</li>
        <li class="mt-3">
          <span v-html="$t('supportTextForSetup', { supportEmail: $t('supportEmailLink') })"></span>
        </li>
      </ul>

      <Button
        :label="$t('take-me-to-my-league-and-team-management-portal')"
        @click="redirect"
        style="background: #E90038"
        class="p-button-lg mt-5"
      />
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    redirect() {
      window.location.href = "https://manage.portal.cactusware.com/user/sign_up";
    },
  },
};
</script>
